// Validación de RUT chileno - Módulo 11
export function validateRut(rut: string): { valid: boolean; formatted: string } {
  const clean = rut.replace(/[.\-\s]/g, '').toUpperCase();
  if (clean.length < 2) return { valid: false, formatted: rut };
  const body = clean.slice(0, -1);
  const dv = clean.slice(-1);
  if (!/^\d+$/.test(body)) return { valid: false, formatted: rut };
  // Módulo 11
  let sum = 0;
  let mul = 2;
  for (let i = body.length - 1; i >= 0; i--) {
    sum += parseInt(body[i]) * mul;
    mul = mul === 7 ? 2 : mul + 1;
  }
  const expected = 11 - (sum % 11);
  const dvExpected = expected === 11 ? '0' : expected === 10 ? 'K' : String(expected);
  const valid = dv === dvExpected;
  // Format
  const formatted = body.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '-' + dv;
  return { valid, formatted };
}

export function formatRut(value: string): string {
  const clean = value.replace(/[^\dkK]/g, '').toUpperCase();
  if (clean.length <= 1) return clean;
  const body = clean.slice(0, -1);
  const dv = clean.slice(-1);
  return body.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '-' + dv;
}

export const formatCLP = (n: number) =>
  new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0 }).format(n);

export function getWhatsAppLink(phone: string, message: string = ''): string {
  const clean = phone.replace(/[^\d+]/g, '');
  const num = clean.startsWith('+') ? clean.slice(1) : clean;
  return `https://wa.me/${num}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
}

export function getEmailLink(email: string, subject: string = '', body: string = ''): string {
  const params = [];
  if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
  if (body) params.push(`body=${encodeURIComponent(body)}`);
  return `mailto:${email}${params.length ? '?' + params.join('&') : ''}`;
}

export const WHATSAPP_TEMPLATES: Record<string, string> = {
  'Prospecto': 'Hola, soy de ConectaCRM. Me gustaria presentarle nuestros servicios. Tiene un momento para conversar?',
  'Contacto Realizado': 'Hola, siguiendo con nuestra conversacion, le envio la informacion solicitada.',
  'Cotizacion Enviada': 'Hola, le envie una cotizacion por correo. Quedo atento a sus comentarios.',
  'Negociacion/Seguimiento': 'Hola, queria saber si tuvo oportunidad de revisar nuestra propuesta. Hay algo que podamos ajustar?',
  'cobranza': 'Hola, le escribo para recordarle que tiene un pago pendiente. Por favor, confirme la recepcion.',
};
